// import { IPageAddCallback, api } from './index';
// import { PageType } from '../const';
import { lang } from "../context";
import { Checkbox, Modal } from "antd";
const { confirm } = Modal;
import events from "../context/events";
import { IAddCallback } from "./index";
import { downloadModal } from "../contextModal/DownloadModal";

// eslint-disable-next-line max-params
const Download: IAddCallback = (props, isAllow, isTeam, currentRouterInfo, type) => {
  const { data: propsData } = props;
  // console.log(propsData, "datadatadatadata111", type);
  // if (data.page_type !== PageType.File) {
  //     return;
  // }
  return [
    {
      children: lang("ctx.download.title"),
      callbackOrModal: async () => {
        console.log(propsData, "callbackOrModal======================>");
        downloadModal({
          newList: Array.from(propsData),
          type
        });
        // confirm({
        //     title: '您的下载操作将被记录，是否确认下载?',
        //     okText: '确定',
        //     cancelText: '取消',
        //     // content: renderContent?.(),
        //     async onOk() {
        //         // let pageList: any = Array.from(propsData);
        //         // events.emit('batchDownload:addTaskList', pageList);
        //     },
        //     onCancel() {
        //         console.log('Cancel');
        //     },
        // });
      },
      isAllow,
      type: "download",
      icon: "pc_yundoc_download",
      splitCode: 1
    }
  ];
};

export default Download;
